"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFrequenceTransactionCorporationTrads = void 0;
exports.ESubFrequenceTransactionCorporationTrads = {
    annuelle: "Annuelle",
    annuelle_supereur: "> 1 an",
    mensuelle: "Mensuelle",
    trimestrielle: "Trimestrielle",
};
